import React, { useContext, useCallback, useRef, useEffect, useState } from 'react';
import { TableContext } from '../table/context/TableContext';
import debounce from 'lodash/debounce';

const QuickFilter = ({ debounceMs = 300 }) => {
  const { filterText, setFilterText } = useContext(TableContext);
  const [inputValue, setInputValue] = useState(filterText);

  // Update input value when filterText changes (e.g. on load)
  useEffect(() => {
    setInputValue(filterText);
  }, [filterText]);

  const handleChange = useCallback((e) => {
    const value = e.target.value;
    setInputValue(value); // Update input immediately
    requestAnimationFrame(() => {
      setFilterText(value); // Update filter immediately
    });
  }, [setFilterText]);

  const handleClear = useCallback(() => {
    setInputValue(''); // Update input immediately
    requestAnimationFrame(() => {
      setFilterText(''); // Update filter immediately
    });
  }, [setFilterText]);

  return (
    <div className="relative">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <svg 
          className="h-5 w-5 text-gray-400" 
          xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 20 20" 
          fill="currentColor"
        >
          <path 
            fillRule="evenodd" 
            d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" 
            clipRule="evenodd" 
          />
        </svg>
      </div>
      <input
        type="text"
        id="quick-filter-search"
        name="quick-filter-search"
        value={inputValue}
        onChange={handleChange}
        placeholder="Search..."
        className="block w-full pl-10 pr-8 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
      />
      {inputValue && (
        <button
          onClick={handleClear}
          className="absolute inset-y-0 right-0 pr-3 flex items-center"
          aria-label="Clear search"
        >
          <svg 
            className="h-5 w-5 text-gray-400 hover:text-gray-500" 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 20 20" 
            fill="currentColor"
          >
            <path 
              fillRule="evenodd" 
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" 
              clipRule="evenodd" 
            />
          </svg>
        </button>
      )}
    </div>
  );
};

export default React.memo(QuickFilter);
